import React, { useEffect } from "react";
import { API_BASE_URL } from "../config";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./PaymentCancel.css"; // Make sure to create this CSS file

const AppointmentPaymentCancel = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const profileId = searchParams.get("profile_id");
  const packageId = searchParams.get("package_id");

  useEffect(() => {
    // const logCancellation = async () => {
    //   try {
    //     await axios.get(
    //       `${API_BASE_URL}/stripe/payment-cancel`,
    //       {
    //         params: { profile_id: profileId, package_id: packageId },
    //       }
    //     );
    //   } catch (error) {
    //     console.error("Error logging payment cancellation:", error);
    //   }
    // };

    // logCancellation();
  }, [profileId, packageId]);

  return (
    <>
      <Navbar />
      <div className="payment-cancel-container">
        <img
          src="/paymentcancel.png"
          alt="Payment Cancelled"
          className="cancel-image"
        />
        <h2>Payment Cancelled</h2>
        <p>We're sorry to inform you that your payment has been cancelled.</p>
        <p>Please try again or contact support if you have questions.</p>
        <button className="home-button" onClick={() => navigate("/")}>
          Go Back
        </button>
      </div>
      <Footer />
    </>
  );
};

export default AppointmentPaymentCancel;
